import React from "react";
import {
    Grid, Button,
    Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DialogFixedForm } from "./../../../../component/common/Forms";
import CentrePostFieldList from "./../../../../component/form/centreComponent/CentrePostFieldList";
import { createCentrePostFormSchema, INITIAL_CENTRE_POST_FORM } from "./../../../../component/form/model/CentreFormModel";
import { addCentrePost, updateCentrePost } from "./../../../../redux/CentreManagement";
import { yupResolver } from "@hookform/resolvers/yup";


export default function CentrePostDialog({
    title, editTitle, currentPost, isDialogOpen, setIsDialogOpen }) {
    const { t } = useTranslation(["general", "config"]);

    const { centreId } = useParams();

    const CENTRE_POST_FORM_METHOD = useForm({
        resolver: yupResolver(createCentrePostFormSchema())
    });

    React.useEffect(() => {
        if (currentPost) {
            CENTRE_POST_FORM_METHOD.reset(currentPost);
        } else {
            CENTRE_POST_FORM_METHOD.reset(INITIAL_CENTRE_POST_FORM);
        }

    }, [isDialogOpen])


    const closeDialog = () => {
        setIsDialogOpen(false);
    }

    const submitMethod = (data) => {
        if (currentPost) {
            editCentrePost(data);
        } else {
            addNewCentrePost(data);
        }
    }

    const editCentrePost = (data) => {
        data.centreId = centreId;
        data._id = currentPost._id;
        updateCentrePost(data);
        setIsDialogOpen(false);
    }

    const addNewCentrePost = (data) => {
        data.centreId = centreId;
        addCentrePost(data);
        setIsDialogOpen(false);
    }

    return (
        <Dialog
            open={isDialogOpen}
            onClose={closeDialog}
            scroll="paper"
            maxWidth="md"
            fullWidth
            aria-labelledby="responsive-dialog-title"
        >
            <FormProvider {...CENTRE_POST_FORM_METHOD} >
                <DialogFixedForm control={CENTRE_POST_FORM_METHOD.control}
                    errors={CENTRE_POST_FORM_METHOD.errors}
                    onSubmit={CENTRE_POST_FORM_METHOD.handleSubmit(submitMethod
                    )}>
                    <DialogTitle id="responsive-dialog-title">
                        {currentPost ? editTitle : title}
                    </DialogTitle>
                    <DialogContent dividers>
                        <CentrePostFieldList />
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between">
                            <Button autoFocus onClick={closeDialog} variant="outlined">
                                {t("general:button-cancel")}
                            </Button>
                            <Button type="submit" variant="contained" >
                                {t("general:button-post")}
                            </Button>
                        </Grid>
                    </DialogActions>
                </DialogFixedForm>
            </FormProvider>
        </Dialog >
    )
}